import { finance } from "../data";
/** @param {Phaser.Scene} scene*/
export const createCoins = (scene, scaleX, width) => {
  scene.physics.add
    .sprite(width - 100 * scaleX, 50 * scaleX, "coin0")
    .setOrigin(1, 0.5)
    .setScale(0.3 * scaleX)
    .play("coin");
  let coinsAmountText = scene.add
    .text(width - 90 * scaleX, 50 * scaleX, finance.coins, {
      color: "#FFFF00",
      fontSize: "50px",
      fontFamily: "grooving",
      strokeThickness: 7,
      stroke: "#F9B100",
    })
    .setOrigin(0, 0.5)
    .setScale(scaleX);
  return coinsAmountText;
};

/** @param {Phaser.Scene} scene*/
export const createFreePlay = (scene, scaleX, width) => {
    scene.add
      .image(width - 100 * scaleX, 130 * scaleX, "freePlay")
      .setOrigin(1, 0.5)
      .setScale(0.15 * scaleX);
    scene.add
      .text(
        width - 90 * scaleX,
        145 * scaleX,
        finance.freePlay,
        {
          color: "#ffffff",
          fontSize: "65px",
          fontFamily: "grooving",
        }
      )
      .setOrigin(0, 0.5)
      .setScale(scaleX);
};
